import React from 'react';
import { InputGroup, Input } from 'reactstrap';

const CommonSelect = props => {

    return (
        <InputGroup>
            <Input
                type='select'
                name={props.inputName}
                style={{ borderRadius: 0, marginRight: 10 }}
                onChange={props.changeState}
                value={props.inputValue}
            >
                <option selected={true} disabled={true} value='' hidden={!props.defaultOptionText}>
                    {props.defaultOptionText}
                </option>
                {
                    props.options.map((option, i) => {
                        return <option key={option + i} value={option}>{option}</option>
                    })
                }
            </Input>
        </InputGroup>
    );
}

export default CommonSelect;


// WEBPACK FOOTER //
// ./src/components/systemControl/database/common/CommonSelect.js